<h2 mat-dialog-title>Alterar Data: Entrega - {{ data.entregaNumber }}</h2>
<mat-dialog-content>
  <div class="split-order-content">
    <div class="calendar-section">
      <div class="months-grid">
        @for (month of months; track month) {
          <div
            class="month-cell"
            [class.selected]="month.isSelected"
            [class.available]="month.isAvailable"
            [class.disabled]="!month.isAvailable"
            (click)="selectMonth(month)">
            <div class="month-name">{{ month.month.toUpperCase() }}</div>
            <div class="year">{{ month.year }}</div>
            <div class="delivery-number">
              {{ month.isSelected ? "Entrega " + data.entregaNumber : "\u00A0" }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancelar</button>
  <button mat-raised-button
    color="primary"
    (click)="confirmSelection()"
    [disabled]="!hasSelectedMonth()">
    Confirmar
  </button>
</mat-dialog-actions>